import { render } from "./reportDishKDStime.vue?vue&type=template&id=452e5d15"
import script from "./reportDishKDStime.vue?vue&type=script&lang=js"
export * from "./reportDishKDStime.vue?vue&type=script&lang=js"

import "./reportDishKDStime.vue?vue&type=style&index=0&id=452e5d15&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__